import { IpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import type {
  GraphPathLookupParameters,
  GraphTopologyParameters,
  PathLookupGraphPreset,
  TopologyGraphPreset,
} from '@ipfabric/utils';
import type { GraphMetadata, Pathlookup } from 'components/Graph/GraphState';
import { isPresetValid } from 'components/Graph/helpers/isPresetValid';
import { omit } from 'utils/object/omit';

const validateTopologyPreset = (preset: TopologyGraphPreset): void => {
  if (!isPresetValid(preset)) {
    throw new IpfError(
      'INVALID_ARGUMENT',
      'cannot save view, preset is invalid',
    );
  }
};

interface GetViewAttributes {
  preset: TopologyGraphPreset | PathLookupGraphPreset;
  parameters: GraphTopologyParameters | GraphPathLookupParameters;
}

export const getViewAttributes = (
  graphMetadata: GraphMetadata | null,
  pathlookup: Pathlookup,
  preset: TopologyGraphPreset,
): GetViewAttributes => {
  if (graphMetadata?.parameters.type === 'pathLookup') {
    return {
      parameters: graphMetadata.parameters,
      preset: pathlookup.preset,
    };
  }
  if (graphMetadata?.parameters.type === 'topology') {
    validateTopologyPreset(preset);
    return {
      parameters: omit(['layouts'], graphMetadata.parameters),
      preset,
    } as const;
  }
  throw new IpfError('GENERIC', 'No graph loaded, cannot save view');
};
